<template>
    <div class="container-fluid layout-wrapper">

        <!--<div class="row text-center">-->

        <!--<div class="col-lg-6 col-sm-6 mb-3">-->
        <!--<div class="input-group round">-->
        <!--<div class="input-group-prepend">-->
        <!--<span class="input-group-text">از تاریخ</span>-->
        <!--</div>-->
        <!--<date-picker type="date" class="date-picker" format="jYYYY-jMM-jDD" :auto-submit="true"-->
        <!--@input="onStartDatePicked" ref="datePickerStart"-->
        <!--style="flex: 1; display: flex;">-->
        <!--<input class="form-control flex-grow-1 date-text-input" v-model="startDatePersian" readonly="true"-->
        <!--@click="toggleStartDatePicker">-->
        <!--</date-picker>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="col-lg-6 col-sm-6 mb-3">-->
        <!--<div class="input-group round">-->
        <!--<div class="input-group-prepend">-->
        <!--<span class="input-group-text">تا تاریخ</span>-->
        <!--</div>-->
        <!--<date-picker type="date" class="date-picker" format="jYYYY-jMM-jDD" :auto-submit="true"-->
        <!--@input="onEndDatePicked" ref="datePickerEnd"-->
        <!--style="flex: 1; display: flex;">-->
        <!--<input class="form-control flex-grow-1 date-text-input" v-model="endDatePersian" readonly="true"-->
        <!--@click="toggleEndDatePicker">-->
        <!--</date-picker>-->
        <!--</div>-->
        <!--</div>-->

        <!--</div>-->
        <hr/>
        <!--<preloader v-if="isLoading"/>-->
        <!--<div v-else>-->

        <div class="row">
            <div class="table-responsive">

                <div>
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th>تاریخ سند</th>
                            <th>شماره سند</th>
                            <!--<th>تاریخ برگه</th>-->
                            <!--<th>شماره برگه</th>-->
                            <th>مبلغ</th>
                            <th>مشتری</th>
                            <!--<th>وضعیت مالیاتی</th>-->
                            <th>عملیات</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in vouchers">
                            <td>{{item.fvoucherDate}}</td>
                            <td class="text-nowrap">{{item.voucherNumber}}</td>
                            <!--<td>{{item.mainVoucherDate}}</td>-->
                            <!--<td>{{item.mainVoucherNumber}}</td>-->
                            <td>{{item.totalPrice.toLocaleString()}}</td>
                            <td>{{item.fullName}}</td>
                            <td>
                                <span @click="onTaxSendClicked(item)" class="clickable px-2" title="ارسال به سامانه">
                                    <i class="fa fa-send"></i>
                                </span>
                                <span @click="onEditClicked(item)" class="clickable px-2" title="تغییر شماره و تاریخ سند">
                                    <i class="fa fa-pencil"></i>
                                </span>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>


        </div>

        <div class="row">
            <div v-if="vouchers !== undefined && vouchers.length < 1" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="vouchers.length < dataCount" class="col-lg-12 text-center my-3">
                <button class="btn btn-success" @click="getVouchers">نمایش اسناد بیشتر
                    ({{vouchers.length}}/{{dataCount}})
                </button>
                <div class="col-2 offset-5 my-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تعداد نمایش</span>
                        </div>
                        <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                    </div>
                </div>
            </div>
        </div>
        <!---------------------- MODALS ------------------------------>
        <!--<div class="modal fade" id="editData" tabindex="-1" role="dialog" aria-labelledby="errorTitle"             aria-hidden="true">-->
        <modal show="false" ref="editModal">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">اصلاح شماره و تاریخ سند</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeeditData()">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-12 mb-3">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ جدید</span>
                                </div>
                                <date-picker type="date" class="date-picker" format="jYYYY-jMM-jDD" :auto-submit="true"
                                             @input="onStartDatePicked" ref="datePickerStart"
                                             style="flex: 1; display: flex;">
                                    <input class="form-control flex-grow-1 date-text-input" v-model="startDatePersian" readonly="true"
                                           @click="toggleStartDatePicker">
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره جدید</span>
                                </div>
                                <input class="form-control flex-grow-1 date-text-input" v-model="newNumber">
                            </div>
                        </div>
                        <div>
                            <button class="col-12 mb-3 round btn btn-success text-center" @click="onSaveClicked"> ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        <!--</div>-->
        </modal>
        <!---------------------- MODALS ------------------------------>
        <div class="modal fade" id="errorData" tabindex="-1" role="dialog" aria-labelledby="errorTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="errorTitle">خطاهای سامانه</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeErrorData()">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <h6 class="text-center mt-5">لطفا پس از رفع خطاهای یاد شده و اصلاح فاکتور، مجددا فاکتور را به سامانه مالیاتی ارسال نمایید</h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">کد خطا</th>
                                    <th class="text-center text-nowrap">متن خطا</th>
                                    <th class="text-center text-nowrap">نوع خطا</th>
                                </tr>
                                </thead>
                                <tbody v-if="errorDatas !== undefined">
                                <tr v-for="(item,index) in errorDatas">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.code}}</td>
                                    <td class="text-center">{{item.message}}</td>
                                    <td class="text-center">{{item.isWarning ?
                                        "اخطار-Warning"
                                        :
                                        "خطا-Error"
                                        }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <button type="button" @click="closeErrorData()"> بستن</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">قیمت خرید</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت فروش</th>
                                </tr>
                                </thead>
                                <tbody v-if="voucher !== undefined">
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center">
                                        {{item.totaltotalPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center">
                                        {{item.salestotaltotalPrice.toLocaleString()}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-left"><b>جمع</b></td>
                                    <td class="text-center" v-if="voucher.voucher !== undefined">
                                        <b>{{voucher.voucher.totaltotalPrice.toLocaleString()}}</b>
                                    </td>
                                    <td class="text-center"><b>{{overallAmount.toLocaleString()}}</b></td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                            <h4 class="text-center mt-5"
                                v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت
                                نشده است!</h4>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-pencil"></i></span>
                            </div>
                            <input v-if="voucher.voucher !== undefined" class="form-control" type="text"
                                   v-model="voucher.voucher.description" placeholder="توضیحات" disabled>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-right w-100">
                            <span>تاریخ سند: </span>
                            <span v-if="voucher.voucher !== undefined">{{voucher.voucher.persianDate}}</span>
                        </div>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="voucherDataEdit" tabindex="-1" role="dialog" aria-labelledby="voucherTitleEdit"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleEdit">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!--<div class="modal-body" id="printMe">-->
                    <div class="modal-body">
                        <div class="table-responsive" id="printMe" v-if="voucher !== undefined">
                            <h6 class="text-center">
                                {{voucher.voucher !== undefined ? voucher.voucher.receiveOutSourceName : ''}}
                                تاریخ
                                {{ voucher.voucher !== undefined ? voucher.voucher.persianDate : '' }}
                                سند شماره
                                {{ voucher.voucher !== undefined ? voucher.voucher.voucherNumber : ''}}
                            </h6>
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in voucher.products">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.productName}}</td>
                                    <td class="text-center  pb-0">
                                        {{item.unitVal}}
                                    </td>
                                    <td class="text-center pb-0">
                                        {{item.salestotaltotalPrice.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{item.discount.toLocaleString()}}
                                    </td>
                                    <td class="text-center">
                                        {{((item.salestotaltotalPrice-item.discount) * item.unitVal).toLocaleString()}}
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <h4 class="text-center mt-5"
                            v-if="voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت نشده
                            است!</h4>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">تخفیف فاکتور</span>
                            </div>
                            <span class="input-group-text">{{voucher.voucher !== undefined  && voucher.voucher.discount !== undefined? voucher.voucher.discount.toLocaleString() : 0}}</span>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-pencil"></i></span>
                            </div>
                            <input class="form-control" type="text" v-if="voucher.voucher !== undefined" v-model="voucher.voucher.description"
                                   placeholder="توضیحات" disabled>
                        </div>
                        <div class="text-center w-100 p-3 text-bold">
                            <span>وضعیت مالیاتی : </span>
                            <span v-if="voucher.voucher !== undefined">{{voucher.voucher.invoiceNumber}}</span>
                            <button v-if="voucher.voucher !== undefined && voucher.voucher.invoiceNumber === 'FAILED'" type="button" class="btn btn-danger" title="مشاهده خطاها"
                                    @click="onErrorDataClicked(voucher.voucher.id)"><i class="fa fa-eraser"></i></button>
                        </div>
                        <div class="text-center w-100 p-3 text-bold">
                            <span>قابل پرداخت : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.totaltotalPrice)).toLocaleString()}}</span>
                            <span>باقیمانده : </span>
                            <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.totaltotalPrice) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.totaltotalPrice; }, 0)).toLocaleString()}}</span>
                        </div>
                        <!--<hr class=" w100"/>-->
                        <h5 class="w-100 text-center">لیست پرداختها</h5>
                        <div class="w-100 " v-if="voucher.payments !== undefined">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class=" text-nowrap text-center">مبلغ</th>
                                    <th class=" text-nowrap text-center">تاریخ</th>
                                    <th class="text-center">توضیحات</th>
                                </tr>
                                </thead>
                                <tbody v-if="voucher !== undefined">
                                <tr v-for="(item,index) in voucher.payments">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td>{{item.totalPrice.toLocaleString()}}</td>
                                    <td class="text-nowrap">{{item.fdate}}</td>
                                    <td class="text-center">
                                        {{item.code}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger" @click="onTaxSendClicked(voucher.voucher)" v-if="voucher.voucher !== undefined">ارسال به سامانه مالیاتی
                        </button>
                        <button type="button" class="btn btn-primary" @click="onModalEditClicked">ویرایش</button>
                    </div>
                </div>
            </div>
        </div>
        <a id="printPaper" class="d-none"></a>
        <!--</div>-->
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper2 from 'vue-html-to-paper';
    import html2canvas from 'html2canvas';
    import axios from "axios";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'sellFactors',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                editedVoucher:{},
                errorDatas: [],
                vouchers: [],
                voucher: {},
                overallAmount: 0,
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                },
                dataCount: 0,

                listView: true,
                isLoading: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                newNumber: "",
                endDatePersian: "",
                providers: [],
                groupSend: [],
                selectedProvider: 0,

            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper2, printoptions);

            // this.listView = JSON.parse(localStorage.getItem("listView"));
            // EventBus.$on('listView', value => {
            //     this.listView = value;
            // });
            this.getVouchers(-1);
            // this.getProviders();
        },
        methods: {
            changePageSize(e) {
                this.getVouchers(-1);
            },
            onErrorDataClicked(uid) {
                new BaseService('TaxService', `/GetErrorDataByVoucher/${uid}`).getList().then(response => {
                    this.errorDatas = response.data.value;
                    if (this.errorDatas !== null && this.errorDatas.length > 0) {
                        $("#errorData").modal("show");
                    } else {
                        this.$noty.success("خطایی یافت نشد، مجددا بروز رسانی فرمائید");
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            closeErrorData() {
                $("#errorData").modal("hide");
            },
            closeeditData() {
                $("#editData").modal("hide");
            },
            onSaveClicked(){
                // this.editedVoucher;
                this.editedVoucher.voucherNumber = this.newNumber;
                new BaseService('TaxService/EditVoucherInfo').update(this.editedVoucher).then(response => {
                    this.$noty.success("اطلاعات با موفقیت ویرایش شد.");
                    this.getVouchers(-1);

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
                this.$refs.editModal.hideModal();
            },
            onEditClicked(item){
                this.editedVoucher = item;
                console.log(item)
                this.startDatePersian = Moment(this.editedVoucher.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                this.newNumber=  this.editedVoucher.voucherNumber;
                // $("#editData").modal("show");
                this.$refs.editModal.showModal();
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            getVouchers(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                this.queryParams.type = 1;
                $("#loading").show();
                new BaseService('TaxService', '/getvoucherreport').getList(this.queryParams).then(response => {
                    let newItems = response.data.value;
                    this.dataCount = newItems.length;
                    for (let item of newItems) {
                        item.fvoucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                    this.vouchers.push.apply(this.vouchers, newItems);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    if (this.voucher.payments != undefined && this.voucher.payments != null) {
                        for (let i of this.voucher.payments) {
                            i.fdate = Moment(i.check.checkDate, 'YYYY-MM-DD HH:mm').format('jYYYY/jMM/jDD-HH:mm');
                        }
                    }
                    let todayDate = new Date().toJSON().slice(0, 10);
                    this.voucher.voucher.voucherDate = this.voucher.voucher.voucherDate.slice(0, 10);
                    this.voucher.pdate = this.voucher.voucher.persianDate;
                    this.voucher.vNum = this.voucher.voucher.voucherNumber;
                    this.voucher.name = this.voucher.voucher.receiveOutSourceName;

                    if (this.voucher.voucher.voucherDate <= todayDate) {

                        $("#voucherDataEdit").modal("show");
                    } else {

                        $("#voucherData").modal("show");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            getProviders() {
                this.queryParams = {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 3
                };
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.providers = response.data.data;
                    let allPro = {
                        id: 0,
                        outSourceName: "همه مشتری ها"
                    };
                    this.providers.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
                this.queryParams = {
                    pageSize: 12,
                    pageIndex: 0,
                    name: "",
                    type: 1
                };

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                console.log(val)
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.editedVoucher.voucherDate = this.fromDate;
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                this.queryParams = {
                    // reciveId: this.selectedProvider,
                    from: this.fromDate,
                    to: this.toDate,
                    // pageSize: 12,
                    // pageIndex: 0,
                    // type: 1

                };
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            onChange(val) {
                this.selectedProvider = val.id;
                this.queryParams = {
                    reciveId: this.selectedProvider,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                };
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    this.vouchers = response.data.data;
                    this.dataCount = response.data.count;
                    $("#loading").hide();
                    for (let item of this.vouchers) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });


            },
            onTaxSendClicked(item) {
                $("#loading").show();
                new BaseService('TaxService', `/MakeReady/${item.id}`).getList().then(response => {
                    this.$noty.success("فاکتور با موفقیت ارسال شد. از بخش پیگیری آخرین وضعیت فاکتورها را مشاهده کنید");
                    // $("#voucherDataEdit").modal("hide");
                    this.getVouchers(-1);

                    $("#loading").hide();
                }).catch(error => {
                    $("#loading").hide();
                    Utils.handleErrorWithNotification("خطا: لطفا مجددا تلاش کنید", this.$noty);
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onModalEditClicked() {
                if (localStorage.getItem("companyPostName") === 'مدیر') {
                    $("#voucherDataEdit").modal("hide");
                    // if (this.voucher.type === "buy") {
                    let newVoucher = this.voucher.voucher;
                    newVoucher.voucherProductDto = this.voucher.products;
                    newVoucher.overallAmount = 0;
                    for (let pro of newVoucher.voucherProductDto) {
                        newVoucher.overallAmount += pro.unitVal;
                        newVoucher.selltotalPrice = pro.salestotalPrice;
                    }
                    newVoucher.overalltotalPrice = newVoucher.totalPrice;

                    let obj = {
                        name: 'sell',
                        params: {
                            id: this.voucher.voucher.receiveOutSourceId,
                            outSourceName: this.voucher.voucher.receiveOutSourceName,
                            voucher: newVoucher,
                            fromEdit: true
                        }
                    };
                    this.$router.push(obj);
                    // } else {
                    //     let obj = {
                    //         name: 'sell',
                    //         params: {
                    //             voucher: this.voucher
                    //         }
                    //     };
                    //     this.$router.push(obj);
                    // }
                } else {
                    this.$noty.success("با عرض پوزش، شما مجاز به ویرایش رسید نیستید.");
                }
            },
            onVoucherRemoveClicked(item) {
                if (confirm("در صورت تایید اطلاعات دریافت و کالاهای آن حذف میشوند. آیا حذف فاکتور را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${item.id}`).create().then(response => {
                        this.$noty.success('سند با موفقیت حذف شد');
                        this.getVouchers(-1);
                        $("#voucherDataEdit").modal("hide");
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onPaymentClicked(item) {
                let remain = parseInt(item.voucher.totalPrice) - item.payments.reduce((acc, itt) => {
                    return acc += itt.totalPrice;
                }, 0);
                item.voucher.overalltotalPrice = remain;
                item.voucher.overallAmount = 0;
                for (let p of item.products) {
                    item.voucher.overallAmount += p.unitVal;
                }
                if (!isNaN(item.voucher.overalltotalPrice) && !isNaN(item.voucher.overallAmount)) {
                    item.voucher.voucherProductDto = item.products;
                    $("#voucherDataEdit").modal("hide");
                    let obj = {
                        name: 'payment',
                        path: '/payment',
                        params: {
                            voucher: item.voucher,
                            type: "sell"
                        }
                    };


                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                if ($("#voucherDataEdit").hasClass("show")) {
                    $("#voucherDataEdit").modal("hide");
                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>